// Self-hosting this font to save on network requests
require("typeface-catamaran");
require("typeface-open-sans");

exports.onInitialClientRender = require("./configs/gatsby/onInitialClientRender");
exports.shouldUpdateScroll = require("./configs/gatsby/shouldUpdateScroll");
exports.wrapRootElement = require("./configs/gatsby/wrapRootElement");
